import * as React from 'react';
import {
  Container, Divider, Card, Box, Typography, Link
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';
import ActivePlayersChart from 'components/ActivePlayersChart'
import { useTranslation } from "react-i18next";
import PageWrapperBox from 'components/PageWrapperBox';

export default function ExperimentalPage() {

    const { t } = useTranslation();
    
  
    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div">
                {t("experimental.title")}
            </Typography>
            
            </PageWrapperBox>

            <ActivePlayersChart/>
    </PageWrapper>
}